/** @file axisColors: the X / Y / Z colours of a field's left border (the viewport axis hexes, copied). */

/** Hexes copied from the viewport palette (`VIEWPORT_COLORS.axisX/Y/Z`) so the ui-kit does not import a panel. */
export const axisColors = ['#e06c6c', '#7bd88f', '#6ca8e0'] as const;
